import { Controller } from "@hotwired/stimulus"

export default class RvCampingMapController extends Controller {
  static targets = ["modal"]

  connect() {
    // Add event listener for escape key
    document.addEventListener("keydown", this.handleKeyDown.bind(this))
  }

  disconnect() {
    // Remove event listener when controller disconnects
    document.removeEventListener("keydown", this.handleKeyDown.bind(this))
  }

  showMap() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden") // Prevent scrolling when modal is open
  }

  hideMap() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden") // Restore scrolling
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.hideMap()
    }
  }

  // Close modal when clicking outside the image
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.hideMap()
    }
  }
}